<template>
    <ModalComponent
        :name="'editTransaccion-' + transaccion.id"
        title="Editar transacción"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" class="row" @submit.prevent="submit">
            <div class="col-12">
                <div class="form-group">
                    <label for="metodo_pago">Método de pago</label>
                    <select class="form-control" v-model="localTransaccion.metodo_pago">
                        <option v-for="metodo_pago in metodos_pago" :key="metodo_pago.id" :value="metodo_pago.id">{{metodo_pago.nombre}}</option>
                    </select>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="fecha_transaccion">Fecha de la transacción</label>
                    <input
                        type="datetime-local"
                        id="fecha_transaccion"
                        name="fecha_transaccion"
                        v-model="localTransaccion.fecha"
                    />
                </div>
            </div>
            <div class="col-12 mt-3">
                <Button type="submit" :disabled="loading">Guardar</Button>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['transaccion', 'params', 'ruta'],
        data() {
            return {
                localTransaccion: {
                ...this.transaccion,
                fecha: this.formatDate(this.transaccion.fecha)  
                },
                loading: false
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.editarTransaccion()
                }
            },
            formatDate(dateString) {
                const date = new Date(dateString);
                return date.toISOString().slice(0, 16);
            },
            editarTransaccion() {
                this.loading = true;

                const parametros = this.params;
                parametros.transaccion_id = this.localTransaccion.id,
                parametros.fecha = this.localTransaccion.fecha,
                parametros.metodo_pago = this.localTransaccion.metodo_pago

                this.$store.dispatch(this.config.getVuexAlias(this.ruta), parametros).then(res => {
                    this.close(true);
                }).finally(() => this.loading = false);
            },
            close(actualizar) {
                this.$emit('cerrar', 'editTransaccion-' + this.transaccion.id, actualizar);
            }
        },
        computed: {
            metodos_pago() {
                return this.$store.getters.getTeatro.metodos_pago_abonos_bases.slice();
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
